import React, { useEffect } from "react";
import AboutBanner from "../components/About/AboutBanner";
import AboutMe from "../components/About/AboutMe";
import HomeChoose from "../components/home/HomeChoose";
import AboutEducation from "../components/About/AboutEducation";
import HomeStats from "../components/home/HomeStats";
import AboutExp from "../components/About/AboutExp";
import AboutVideo from "../components/About/AboutVideo";
import AboutContact from "../components/About/AboutContact";
import { useLenis } from "lenis/react";

const AboutPage = () => {
    const lenis = useLenis();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, {
        duration: 1.2,
      });
    }
  }, [lenis]);
  return (
    <>
      <AboutBanner />
      <AboutMe />
      <HomeChoose />
      <AboutEducation />
      <HomeStats />
      <AboutExp />
      <AboutVideo />
      <AboutContact />
    </>
  );
};

export default AboutPage;
